module.exports = __webpack_public_path__ + "img/smartphone.9f4b8c7d.svg";